// DS: i9.15
import React, { useId } from 'react';
import IconWrap, { Props as WrapperProps } from '../../IconWrap';

import s from './TopCustomer.scss';

export interface Props extends WrapperProps {
  position?: 1 | 2 | 3;
}

const TopCustomer: React.FC<Props> = ({ position = 1, ...props }) => {
  const filterId = useId();
  let numeral: string, className: string;
  switch (position) {
    case 1:
      className = s['first'];
      numeral =
        'M14.0021 21V19.082H16.3681V14.07L14.7301 15.134H14.0021V13.44L16.7601 11.55H18.5801V19.082H20.5121V21H14.0021Z';
      break;
    case 2:
      className = s['second'];
      numeral =
        'M13.5486 19.236L16.5446 16.604C16.918 16.2773 17.2026 16.002 17.3986 15.778C17.5946 15.5447 17.73 15.3347 17.8046 15.148C17.8886 14.9613 17.9306 14.7607 17.9306 14.546C17.9306 14.21 17.7953 13.93 17.5246 13.706C17.2633 13.4727 16.8713 13.356 16.3486 13.356C15.882 13.356 15.434 13.4167 15.0046 13.538C14.5846 13.65 14.1553 13.8133 13.7166 14.028L13.5626 12.208C14.0293 11.956 14.524 11.76 15.0466 11.62C15.5786 11.48 16.1293 11.41 16.6986 11.41C17.4266 11.41 18.052 11.536 18.5746 11.788C19.0973 12.0307 19.4986 12.376 19.7786 12.824C20.0586 13.2627 20.1986 13.7713 20.1986 14.35C20.1986 14.77 20.11 15.1713 19.9326 15.554C19.7646 15.9273 19.4986 16.3147 19.1346 16.716C18.7706 17.108 18.3086 17.5513 17.7486 18.046L16.5586 19.082H20.4086V21H13.5486V19.236Z';
      break;
    case 3:
      className = s['third'];
      numeral =
        'M13.1163 20.636L13.2563 18.83C13.667 18.97 14.0683 19.0727 14.4603 19.138C14.8617 19.2033 15.291 19.236 15.7483 19.236C16.3737 19.236 16.8263 19.124 17.1063 18.9C17.3957 18.6667 17.5403 18.3773 17.5403 18.032C17.5403 17.6867 17.3957 17.4207 17.1063 17.234C16.817 17.0473 16.3223 16.954 15.6223 16.954H14.8243V15.386H15.5803C16.243 15.386 16.6817 15.2927 16.8963 15.106C17.1203 14.9193 17.2323 14.672 17.2323 14.364C17.2323 14.0467 17.1017 13.7947 16.8403 13.608C16.5883 13.4213 16.2103 13.328 15.7063 13.328C14.9317 13.328 14.157 13.4587 13.3823 13.72L13.2423 11.9C13.6717 11.7413 14.1057 11.62 14.5443 11.536C14.9923 11.452 15.4777 11.41 16.0003 11.41C16.7097 11.41 17.3257 11.5173 17.8483 11.732C18.371 11.9467 18.777 12.25 19.0663 12.642C19.3557 13.0247 19.5003 13.468 19.5003 13.972C19.5003 14.4293 19.3697 14.826 19.1083 15.162C18.8563 15.4887 18.4877 15.75 18.0023 15.946V16.114C19.2063 16.534 19.8083 17.276 19.8083 18.34C19.8083 18.9093 19.6497 19.4087 19.3323 19.838C19.0243 20.258 18.5857 20.5847 18.0163 20.818C17.447 21.042 16.7703 21.154 15.9863 21.154C15.445 21.154 14.9457 21.112 14.4883 21.028C14.031 20.944 13.5737 20.8133 13.1163 20.636Z';
      break;
    default:
      return null;
  }
  return (
    <IconWrap {...props}>
      <svg
        className={className}
        width="34"
        height="37"
        viewBox="0 0 34 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter={`url(#filter_${filterId})`}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.3985 3.63545C17.6586 2.78818 16.3414 2.78818 15.6015 3.63545L14.681 4.68938C14.2073 5.23179 13.4628 5.45139 12.7707 5.25288L11.436 4.87009C10.359 4.5612 9.25589 5.26943 9.08811 6.37748L8.87208 7.80423C8.76515 8.51042 8.26289 9.09273 7.58019 9.30203L6.21957 9.71918C5.15596 10.0453 4.61567 11.2272 5.06488 12.2452L5.65767 13.5886C5.94401 14.2375 5.83591 14.9929 5.37906 15.5353L4.43689 16.6541C3.72165 17.5035 3.90631 18.7866 4.832 19.3996L6.03745 20.198C6.63025 20.5905 6.94693 21.2872 6.85303 21.9921L6.6601 23.4404C6.51266 24.5471 7.36773 25.533 8.48394 25.5431L9.88564 25.5559C10.603 25.5624 11.2525 25.9817 11.5539 26.633L12.1503 27.9216C12.6224 28.9415 13.8846 29.3117 14.8325 28.7084L16.003 27.9633C16.6113 27.5761 17.3887 27.5761 17.997 27.9633L19.1675 28.7084C20.1154 29.3117 21.3776 28.9415 21.8497 27.9216L22.4461 26.633C22.7475 25.9817 23.397 25.5624 24.1144 25.5559L25.5161 25.5431C26.6323 25.533 27.4873 24.5471 27.3399 23.4404L27.147 21.9921C27.0531 21.2872 27.3698 20.5905 27.9626 20.198L29.168 19.3996C30.0937 18.7866 30.2783 17.5035 29.5631 16.6541L28.6209 15.5353C28.1641 14.9929 28.056 14.2375 28.3423 13.5886L28.9351 12.2452C29.3843 11.2272 28.844 10.0453 27.7804 9.71918L26.4198 9.30203C25.7371 9.09273 25.2349 8.51042 25.1279 7.80423L24.9119 6.37748C24.7441 5.26943 23.641 4.5612 22.564 4.87009L21.2293 5.25288C20.5372 5.45139 19.7927 5.23179 19.319 4.68938L18.3985 3.63545Z"
          />
        </g>
        <path d={numeral} fill="white" />
        <defs>
          <filter
            id={`filter_${filterId}`}
            x="0"
            y="3"
            width="34"
            height="33.9993"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result={`effect1_dropShadow_${filterId}`}
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2={`effect1_dropShadow_${filterId}`}
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </IconWrap>
  );
};
TopCustomer.displayName = 'TopCustomer';

export default TopCustomer;
